import { m } from "framer-motion";
import { ShieldAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

/** Rendered when the module itself is enabled but the current user's role
 * doesn't have access to it (e.g. a non-Super-Admin hitting Role Management,
 * or a user lacking the module permission) — distinct from ModuleDisabled,
 * which is for the organisation not having purchased/enabled the module at
 * all. Using ModuleDisabled's "contact your admin to enable this" copy here
 * would be misleading since the module is already enabled. */
export function NotAuthorized() {
  const { t } = useTranslation("common");

  return (
    <m.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="
        flex flex-col
        items-center
        justify-center
        min-h-[400px]
        p-8
        text-center
        bg-[rgb(var(--card))]
        border border-[rgb(var(--border))]
        rounded-2xl
        shadow-lifted
      "
    >
      <div className="relative mb-6">
        <div
          className="
            absolute inset-0
            bg-red-500
            opacity-10
            blur-xl
            rounded-full
            animate-pulse
          "
        />

        <div
          className="
            relative
            p-5
            bg-[rgb(var(--card-muted))]
            rounded-full
            border border-[rgb(var(--border))]
            text-red-600
          "
        >
          <ShieldAlert size={48} />
        </div>
      </div>

      <h2
        className="
          text-2xl
          font-bold
          text-[rgb(var(--text-primary))]
          mb-2
        "
      >
        {t("titleNotAuthorized")}
      </h2>

      <p
        className="
          text-[rgb(var(--text-muted))]
          max-w-md
          leading-relaxed
        "
      >
        {t("descriptionNotAuthorized")}
      </p>
    </m.div>
  );
}
